import { render, staticRenderFns } from "./DrinkDrivingAdvice.vue?vue&type=template&id=048ee270&scoped=true&"
import script from "./DrinkDrivingAdvice.vue?vue&type=script&lang=ts&"
export * from "./DrinkDrivingAdvice.vue?vue&type=script&lang=ts&"
import style0 from "./DrinkDrivingAdvice.vue?vue&type=style&index=0&id=048ee270&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ee270",
  null
  
)

export default component.exports